// extracted by mini-css-extract-plugin
export default {"visualBox":"pqsArSMvSw9842UP3Yqu"};